import React, { useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'wouter';
import { Home } from 'components/views/Home/Home';
import { Login } from 'components/views/Login/Login';
import { Recovery } from 'components/views/auth/recovery/Recovery';
import { Error } from 'components/views/Error/Error';
import { PoliciesIndividualList } from 'components/views/individual/PoliciesIndividualList';
import { Productos } from 'components/views/Productos/Productos';
import { Reclamaciones } from 'components/views/Reclamations/Reclamaciones';
import { Perfil } from 'components/views/Perfil/Perfil';
import Unauthorized from 'components/views/Unauthotized/Unauthorized';
import { BillingList } from 'components/views/corporation/Billing/BillingList';
import { PoliciesList } from 'components/views/corporation/Policies/PoliciesList';
import { ClaimsList } from 'components/views/corporation/Claims/ClaimsList';
import { refreshToken } from 'Services/tokenService';
import ModalSessionExpiry from './ModalSessionExpiry';
import AlertNotification, { IAlert } from 'components/common/AlertNotification/AlertNotification';
import { url, urlInv } from 'Utils/DBHelper/Helper';

export const Main = () => {
  const [location, setLocation] = useLocation();
  const [alert, setAlert] = useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });

  const token = localStorage.getItem('user');
  const isAuthenticated = () => {
    return !!token;
  };
  const currentPath = window.location.pathname;

  const [tokenExpiry, setTokenExpiry] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!['/login'].includes(location)) {
      const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
      if (storedUser?.user?._changePassword) {
        setLocation("/mi-perfil?op=pW2c");
      }
    }
  }, [location]);


  const onExtendSession = async () => {
    const newTokenData: any = await refreshToken();
    setShowModal(false);
    if (newTokenData?._token) {
      localStorage.setItem('user', JSON.stringify(newTokenData));
      setTokenExpiry(new Date(newTokenData?.claims?._fechaExpiracion).getTime());
    } else {
      setAlert({
        show: true,
        title: 'Error al refrescar el token',
        details: newTokenData || 'Intentelo más tarde',
        variant: 'Danger'
      });
      localStorage.removeItem('user');
      localStorage.removeItem('originalPath');
      setLocation('/login');
    }
  };

  useEffect(() => {
    const checkTokenExpiry = async () => {
      if (isAuthenticated()) {
        if (token) {
          const user = JSON.parse(token)?.claims;
          if (user && user?._fechaExpiracion) {
            const formattedExpireToken = convertTo24HourFormat(user._fechaExpiracion);
            const expiryTime = new Date(formattedExpireToken).getTime();
            setTokenExpiry(expiryTime);
            // Check if the token expired more than 5 minutes ago
            if (expiryTime < Date.now()) {
              localStorage.removeItem('user');
              localStorage.removeItem('originalPath');
              setLocation('/login');
            }
          }
        }
      }
    };

    checkTokenExpiry();
  }, [token, setLocation]);

  function convertTo24HourFormat(fechaStr: any) {
    const [fecha, hora, ampm] = fechaStr.split(/[\s:]+/);
    const [day, month, year] = fecha.split('/');
    let hour = parseInt(hora, 10);
    const minute = fechaStr.match(/(\d{1,2}):(\d{2})/)[2];
    const second = fechaStr.match(/(\d{1,2}):(\d{2}):(\d{2})/)[3];
  
    if (fechaStr.includes('p. m.') && hour < 12) {
      hour += 12;
    }
    if (fechaStr.includes('a. m.') && hour === 12) {
      hour = 0;
    }
  
    // Retorna en formato ISO
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${String(hour).padStart(2, '0')}:${minute}:${second}`;
  }
  

  function isOpenRoute() {
    return !['/mi-perfil'].includes(location);
  }
  useEffect(() => {
    const interval = setInterval(() => {
      if (isAuthenticated()) {
        if (token) {
          const user = JSON.parse(token);
          const expiryTimeStr = convertTo24HourFormat(user.claims?._fechaExpiracion);
    
          if (expiryTimeStr) {
            // Convierte la fecha a un formato legible por Date
            const expiryTime = new Date(expiryTimeStr).getTime();
            if (expiryTime < Date.now()) {
              localStorage.removeItem('user');
              localStorage.removeItem('originalPath');
              setShowModal(false);
              clearInterval(interval);
              setLocation('/login');
            }
          }
          if (tokenExpiry && (tokenExpiry - Date.now()) <= 4000) { // 4 segundos antes de la expiración
            setShowModal(true);
          }
        }
      }
    }, 1000);    

    return () => clearInterval(interval);
  }, [tokenExpiry]);
  // Validate user is logged in
  if (!isAuthenticated() && !['/login', '/recovery'].includes(location)) {
    // Save original route
    localStorage.setItem('originalPath', currentPath);
    setLocation('/login');
    return null;
  } else if (isAuthenticated() && location !== '/') {
    const fullUserData =JSON.parse(token || '')
    if (fullUserData && isOpenRoute()) {
      // Buscar el ID correspondiente al `currentPath`
      const urlObj = fullUserData?.user?._tipoUsuario === 'Individual' ? urlInv : url;
      const matchedMenu = Object.entries(urlObj).find(([_, value]) => value === currentPath.replace('/', ''));
      if (matchedMenu) {
        const id = Number(matchedMenu[0]);
        // Buscar el menú en el array que tenga el mismo ID y verificar si está activo
        const matchedItem = fullUserData?.array_menus.find((item: any) => item._id === id);
        // Si el ítem no está activo, redirigir al 404
        if (!matchedItem || !matchedItem._isActivo) {
          setLocation('/404');
        }
      } else {
        setLocation('/404');
      }
    } else if (isOpenRoute()) {
      setLocation('/404');
    }
  }

  return (
    <main className="main">
      <ModalSessionExpiry show={showModal} onExtendSession={onExtendSession} />
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/recovery" component={Recovery} />

        {/* Client */}
        <Route path="/" component={Home} />
        <Route path="/mis-polizas" component={PoliciesIndividualList} />
        <Route path="/solicitar-productos" component={Productos} />
        <Route path="/mis-reclamaciones" component={Reclamaciones} />
        <Route path="/mi-perfil" component={Perfil} />

        {/* Corporation */}
        <Route path="/facturas" component={BillingList} />
        <Route path="/polizas" component={PoliciesList} />
        <Route path="/reclamaciones" component={ClaimsList} />

        <Route path="/401" component={Unauthorized} />
        <Route path="/:rest*" component={Error} />
      </Switch>

      <AlertNotification
        show={alert?.show}
        title={alert?.title}
        details={alert?.details}
        variant={alert?.variant}
        onClose={() => setAlert({ show: false, title: '', details: '', variant: 'Danger' })}
      />
    </main>
  );
};
